var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tab-layout",
    { attrs: { buttons: _vm.buttons, permissions: _vm.permissions } },
    [
      _c("template", { slot: "title" }, [
        _vm._v("\n        " + _vm._s(_vm.$l10n.__("Paniers")) + "\n    ")
      ]),
      _vm._v(" "),
      _c(
        "template",
        { slot: "content" },
        [
          _vm.shouldDisplayGoToBubbleAlert
            ? _c("CompassAlert", {
                attrs: {
                  description: _vm.$t.__(
                    "overview.tabs.TabSamCartsList.only_cart_created_with_SAM_available"
                  ),
                  action: {
                    label: _vm.$t.__(
                      "overview.tabs.TabSamCartsList.see_cart_created_with_chargebee"
                    ),
                    callback: function() {
                      return _vm.goToBubbleCarts()
                    }
                  },
                  "show-close": false
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.loading
            ? _c(
                "div",
                { staticClass: "prelative mt-3" },
                [_c("preloader", { attrs: { display: _vm.loading } })],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.loading
            ? _c(
                "div",
                { staticClass: "flex-column" },
                [
                  _c("sam-cart-items-list", {
                    attrs: {
                      corporation: _vm.corporation,
                      carts: _vm.carts,
                      products: _vm.products,
                      permissions: _vm.permissions
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }